/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Native_OnInputs */

const th_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดการแจ้งเตือนสำหรับแอปนี้แล้ว`)
};

const en_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are on for this app.`)
};

const ja_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリの通知はオンです。`)
};

const zh_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此应用的通知已打开。`)
};

const es_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notificaciones están activadas para esta aplicación.`)
};

const pt_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As notificações estão ligadas para este aplicativo.`)
};

const id_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi menyala untuk aplikasi ini.`)
};

const fr_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications sont activées pour cette application.`)
};

const tl_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakabukas ang mga notipikasyon para sa app na ito.`)
};

const vi_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo đang bật cho ứng dụng này.`)
};

const ko_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 앱의 알림이 켜져 있습니다.`)
};

const de_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen sind für diese App eingeschaltet.`)
};

const ru_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления для этого приложения включены.`)
};

const tr_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu uygulama için bildirimler açık.`)
};

const it_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le notifiche sono attive per questa app.`)
};

const pl_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia dla tej aplikacji są włączone.`)
};

const uk_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення для цього застосунку ввімкнено.`)
};

const hi_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ऐप के लिए सूचनाएँ चालू हैं।`)
};

const ar_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات مفعّلة لهذا التطبيق.`)
};

const ms_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan dihidupkan untuk aplikasi ini.`)
};

const bn_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই অ্যাপের বিজ্ঞপ্তি চালু আছে।`)
};

const zh_tw2_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個應用程式的通知已開啟。`)
};

const zh_hk2_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個應用程式的通知已開啟。`)
};

const ur_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ایپ کی اطلاعات چالو ہیں۔`)
};

const fa_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌های این برنامه روشن است.`)
};

const sw_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa za programu hii zimewashwa.`)
};

const nl_push_native_on = /** @type {(inputs: Push_Native_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen staan aan voor deze app.`)
};

/**
* | output |
* | --- |
* | "Notifications are on for this app." |
*
* @param {Push_Native_OnInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_native_on = /** @type {((inputs?: Push_Native_OnInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Native_OnInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_native_on(inputs)
	if (locale === "ja") return ja_push_native_on(inputs)
	if (locale === "zh") return zh_push_native_on(inputs)
	if (locale === "es") return es_push_native_on(inputs)
	if (locale === "pt") return pt_push_native_on(inputs)
	if (locale === "id") return id_push_native_on(inputs)
	if (locale === "fr") return fr_push_native_on(inputs)
	if (locale === "tl") return tl_push_native_on(inputs)
	if (locale === "vi") return vi_push_native_on(inputs)
	if (locale === "ko") return ko_push_native_on(inputs)
	if (locale === "de") return de_push_native_on(inputs)
	if (locale === "ru") return ru_push_native_on(inputs)
	if (locale === "tr") return tr_push_native_on(inputs)
	if (locale === "it") return it_push_native_on(inputs)
	if (locale === "pl") return pl_push_native_on(inputs)
	if (locale === "uk") return uk_push_native_on(inputs)
	if (locale === "hi") return hi_push_native_on(inputs)
	if (locale === "ar") return ar_push_native_on(inputs)
	if (locale === "ms") return ms_push_native_on(inputs)
	if (locale === "bn") return bn_push_native_on(inputs)
	if (locale === "zh-TW") return zh_tw2_push_native_on(inputs)
	if (locale === "zh-HK") return zh_hk2_push_native_on(inputs)
	if (locale === "ur") return ur_push_native_on(inputs)
	if (locale === "fa") return fa_push_native_on(inputs)
	if (locale === "sw") return sw_push_native_on(inputs)
	if (locale === "nl") return nl_push_native_on(inputs)
	return en_push_native_on(inputs)
});